import { gql } from '@apollo/client'

export default gql(`
query getBatchBucketItems($input: [ID]){
    getBatchBucketItems(
        input: $input
    ){
        id
        type
        asset{
            id
        }
    }
}`)
